export class ContextMenuOptions{
  items: Array<ContextMenuItem>;
}

export class ContextMenuItem {
  id: string;
  name: string;
  icon: string;
  hasHr: boolean;
  callback;
}
